module.exports = __webpack_public_path__ + "static/media/sn.7ab0a3d4.svg";